import { render, staticRenderFns } from "./FavoriteComponent.vue?vue&type=template&id=79a78c02&scoped=true&"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js&"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteComponent.vue?vue&type=style&index=0&id=79a78c02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a78c02",
  null
  
)

export default component.exports